import styled from '@emotion/styled'
import {Box, Container, Flex, Text} from '@chakra-ui/react'
import Link from '_app/components/Link/Link'
import {addApolloState, initializeApollo} from 'helpers/ApolloHelper/ApolloHelper'
import Button from '_app/components/Buttons/Button'
import PageSimpleHeader from '_app/components/Page/PageSimpleHeader'
import withAppInit from '_app/hoc/withAppInit'
import {Context} from '_app/types/context'
import {GET_WELCOME_CONFIGURATOR_PAGE} from '_app/graphql/cms/queries/GetWelcomeConfiguratorPage'
import {GetWelcomeConfiguratorPageQuery} from '_app/graphql/cms/generated/graphql'
import RequestEnum from '../enums/RequestEnum/RequestEnum'
import I18nHelper from '../helpers/I18nHelper/I18nHelper'
import SeoHelper from '../helpers/SeoHelper/SeoHelper'

interface WelcomeConfiguratorProps {
  cms: GetWelcomeConfiguratorPageQuery;
}

const StyledDescription = styled(Box)`
  strong {
    font-weight: 600;
  }
`

const WelcomeConfigurator = ({ cms }: WelcomeConfiguratorProps) => {
  const pageData = cms?.welcomeConfigurator?.data?.attributes
  return (
    <Box bg="white" pt={8}>
      <PageSimpleHeader
          seo={{
            title: SeoHelper.getTitle(),
            description: SeoHelper.getDescription(),
          }}
      >
        <Container
          pt={{
            base: '0px',
            lg: '72px',
          }}
          pb={{
            base: '142px',
            lg: '0px',
          }}
        >
          <Flex
            pb="0"
            gap={{
              base: '0px',
              lg: '64px',
            }}
            direction={{
              base: 'column-reverse',
              lg: 'row',
            }}
          >
            <Box
              w={{
                base: '100%',
                lg: '50%',
              }}
              height={{
                base: '163px',
                lg: '521px',
              }}
              bgImage={`url('${pageData?.Image?.data?.attributes?.url || ''}')`}
              bgSize="cover"
              bgPosition="center"
              bgRepeat="no-repeat"
            ></Box>
            <Flex
              w={{
                base: '100%',
                lg: '50%',
              }}
              maxW={{
                base: 'unset',
                lg: '536px',
              }}
              flexWrap="wrap"
              flexDir="column"
            >
              {pageData?.Heading && (
                <Text
                  textStyle={{
                    base: 'h3',
                    lg: 'h2',
                  }}
                  pt={{
                    base: '0px',
                    lg: '13px',
                  }}
                  pb="24px"
                  as="h2"
                >
                  {pageData?.Heading}
                </Text>
              )}
              {pageData?.Description && (
                <StyledDescription
                  textStyle="bodyLight"
                  pb="24px"
                  lineHeight="1.7"
                  dangerouslySetInnerHTML={{
                    __html: pageData?.Description || '',
                  }}
                />
              )}
              <Flex
                flexWrap="wrap"
                gap={{
                  base: '12px',
                  lg: '30px',
                }}
                position={{
                  base: 'fixed',
                  lg: 'static',
                }}
                zIndex={{
                  base: '99',
                  lg: '0',
                }}
                bottom="0px"
                left="0"
                right="0"
                bgColor="white"
                p={{
                  base: '15px',
                  lg: '0px',
                }}
              >
                  <Box w={{ base: '100%', lg: 'auto' }}>
                      <Link href={'/configurator?baseGroupId=63107d9da66f2eda78cc9214&baseId=62a19dfdf4b1fe9ad03d925f&selectedMaterialSKU=SZ_C_ROSSO_F&slots=%5B%7B"slotId"%3A"6319a94548d0182b38b61172"%2C"elementSKU"%3A"4%2FE%2FZ"%7D%5D&size=16&url_key=bransoletka-z-pozlacana-okragla-koniczynka-etincelle-na-cienkim-czerwonym-sznurku'}>
                          <Button w={{ base: '100%', lg: 'auto' }} variant="solid">Projektuj Bransoletkę</Button>
                      </Link>
                  </Box>
                  <Box w={{ base: '100%', lg: 'auto' }}>
                    <Link href={'/configurator?baseGroupId=631d9ebf36d65bd321e8addc&baseId=6318b25db742e38bc2a1e082&selectedMaterialSKU=LAN%2FNITKA%2F40%2FPO&slots=%5B%7B"slotId"%3A"631da11436d65bd321e8b201"%2C"elementSKU"%3A"147%2F10%2FZAW%2FM%2FPO"%7D%5D&size=40&url_key=naszyjnik-z-pozlacana-literka-m-na-lancuszku-nitka'}>
                        <Button w={{ base: '100%', lg: 'auto' }} variant="outline">Projektuj Naszyjnik</Button>
                    </Link>
                  </Box>
              </Flex>
            </Flex>
          </Flex>
        </Container>
      </PageSimpleHeader>
    </Box>
  )
}

export const getServerSideProps = withAppInit(async (ctx: Context) => {
  const apolloClient = initializeApollo(null, ctx)

  try {
    const { data: cms } = await apolloClient.query({
      query: GET_WELCOME_CONFIGURATOR_PAGE,
      variables: {
        locale: ctx.locale,
      },
      context: {
        clientName: RequestEnum.CMS_CONTEXT,
      },
    })

    return addApolloState(ctx.apolloClient, {
      props: {
        cms,
        ...(await I18nHelper.getI18nProps(ctx, ['cart'])),
      },
    })
  } catch (error) {
    return {
      notFound: true,
    }
  }
})

export default WelcomeConfigurator
